module.exports = __webpack_public_path__ + "img/birdtv.49896230.png";